// src/services/baseService.ts
import axios, { AxiosRequestConfig, AxiosResponse } from "axios";

export enum HttpMethod {
  GET = "GET",
  POST = "POST",
  PUT = "PUT",
  DELETE = "DELETE",
}

// Cambiar la URL base por la de EasyPH
const DEFAULT_BASE_URL = 'https://api.easyph.com.co/api/';

const apiBaseUrl = process.env.REACT_APP_API_PROD || DEFAULT_BASE_URL;

// Crear una instancia de Axios
const api = axios.create({
  baseURL: apiBaseUrl,
  headers: {
    "Content-Type": "application/json",
    "Accept": "application/json, text/plain;q=0.9,*/*;q=0.8",
  },
});

// Interceptor para agregar token automáticamente
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token && config.headers) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  
  // Si el payload es FormData, eliminar Content-Type para que Axios lo establezca automáticamente
  if (config.data instanceof FormData) {
    delete config.headers['Content-Type'];
  }
  
  return config;
});

// Interceptor de respuesta para manejar errores y 401
api.interceptors.response.use(
  (response: AxiosResponse) => response,
  (error) => {
    // Si es 401, limpiar localStorage y redirigir a login
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('easyph_session');
      // En una app real, aquí podrías redirigir al login
      window.location.href = '/login';
    }
    
    return Promise.reject(error.response || error.message);
  }
);

export const myFetch = async <T>(
  endpoint: string,
  method: HttpMethod,
  payload?: any,
  additionalHeaders?: { [key: string]: string }
): Promise<T> => {
  const config: AxiosRequestConfig = {
    method,
    url: endpoint,
    data: payload,
    headers: {
      ...additionalHeaders,
    },
  };

  // Si el payload es FormData, eliminar Content-Type para que Axios lo establezca automáticamente
  if (payload instanceof FormData) {
    // Eliminar Content-Type para que Axios establezca automáticamente multipart/form-data con boundary
    delete config.headers?.['Content-Type'];
  }

  try {
    const response = await api.request<T>(config);
    return response.data;
  } catch (error: any) {
    // Lanzar error con mensaje del backend o genérico
    const message = error?.data?.message || 
                   error?.message || 
                   "Request failed";
    throw new Error(message);
  }
};

export default api;